import HeaderController from './header-controller'

export default HeaderController
